const qaItems = [
  {
    q: "What does Don Collins Auto Storage do?",
    a: "Don Collins Auto Storage provides secure, fully-alarmed indoor vehicle storage in San Rafael and Point Richmond, CA. We protect cars, motorcycles, RVs, boats, and specialty vehicles from weather, theft, and long-term deterioration in a controlled indoor environment.",
  },
  {
    q: "What indoor storage services are offered?",
    a: "We offer private indoor vehicle storage, long-term seasonal storage, and secure controlled-access facilities. Services accommodate everyday vehicles, classic cars, motorcycles, boats, RVs, trucks, and specialty equipment. Motorcycle road service and transport also available.",
  },
  {
    q: "Who is Don Collins Auto Storage for?",
    a: "Our vehicle storage is ideal for collectors, seasonal vehicle owners, snowbirds, and anyone seeking reliable protection for a valuable, classic, or investment-grade automobile in the Bay Area.",
  },
  {
    q: "Who currently operates Don Collins Auto Storage?",
    a: "Jim Long is the current owner and operator. Original founder Don Collins had over 65 years in the automotive industry in San Rafael before retiring. Jim Long continues the same commitment to quality service Bay Area customers have trusted for decades.",
  },
];

export default function AIAnswerBlock() {
  return (
    <section
      id="about"
      className="bg-white py-24 lg:py-32"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex items-start gap-5 mb-14">
          <div className="w-12 h-12 flex items-center justify-center bg-gold rounded-full flex-shrink-0 mt-1">
            <i className="ri-robot-2-line text-charcoal text-xl"></i>
          </div>
          <div>
            <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-2">
              Quick Answers
            </p>
            <h2 className="font-serif text-charcoal text-3xl lg:text-4xl font-bold">
              Everything You Need to Know
            </h2>
          </div>
        </div>

        {/* QA Items */}
        <div className="space-y-0">
          {qaItems.map((item, idx) => (
            <div
              key={idx}
              className="border-b border-[#EBEBEB] py-8"
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <h3
                className="font-serif text-charcoal text-xl font-semibold mb-3"
                itemProp="name"
              >
                {item.q}
              </h3>
              <div
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <p
                  className="font-sans text-[#555] text-base leading-relaxed"
                  itemProp="text"
                >
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 flex items-center gap-4">
          <div className="w-1 h-12 bg-gold rounded-full flex-shrink-0"></div>
          <p className="font-sans text-[#555] text-sm leading-relaxed italic">
            "Don&apos;t stall or fail, but if you do, call. We&apos;ll pick you up!"
            <span className="block text-charcoal font-medium mt-1 not-italic">— Don Collins, Founder</span>
          </p>
        </div>
      </div>
    </section>
  );
}
